"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bankInfo = void 0;
exports.bankInfo = {
    findBankInfos: {
        method: 'get',
        path: '/bank-info',
        response: {},
    },
    findOneBankInfo: {
        method: 'get',
        params: ['bankCode'],
        path: '/bank-info/:bankCode',
        response: {},
    },
    cardInfo: {
        method: 'get',
        params: ['bin'],
        path: '/card-info/:bin',
        response: {},
    }
};
//# sourceMappingURL=bank-info.api.js.map